// Brand Kits API - Supabase backend via Cloudflare Functions
    const API_BASE='/api';

    export const list=async ()=> {
      try {
        const response=await fetch(`${API_BASE}/brand-kits`);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        const result=await response.json();
        return result.data || [];
      } catch (error) {
        console.error('Failed to list brand kits:',error);
        throw error;
      }
    };

    export const get=async (id)=> {
      try {
        const response=await fetch(`${API_BASE}/brand-kits/${id}`);
        if (!response.ok) {
          if (response.status===404) {
            return null;
          }
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        const result=await response.json();
        return result.data;
      } catch (error) {
        console.error('Failed to get brand kit:',error);
        throw error;
      }
    };

    export const create=async (brandKitData)=> {
      try {
        const response=await fetch(`${API_BASE}/brand-kits`,{
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(brandKitData),
        });
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        const result=await response.json();
        return result.data;
      } catch (error) {
        console.error('Failed to create brand kit:',error);
        throw error;
      }
    };

    export const update=async (id,updates)=> {
      try {
        const response=await fetch(`${API_BASE}/brand-kits/${id}`,{
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates),
        });
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        const result=await response.json();
        return result.data;
      } catch (error) {
        console.error('Failed to update brand kit:',error);
        throw error;
      }
    };

    export const remove=async (id)=> {
      try {
        const response=await fetch(`${API_BASE}/brand-kits/${id}`,{
          method: 'DELETE',
        });
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return true;
      } catch (error) {
        console.error('Failed to delete brand kit:',error);
        throw error;
      }
    };

    // Alias for consistency
    export {remove as delete};